<template>
  <nav>

    <div class="loader-wrapper" v-if='showLoader'>
      <div class="loader"></div>
    </div>
  </nav>
  <router-view />
</template>


<script setup lang="ts">
import { useProductsStore } from "@/store/products"
import { useRouter } from 'vue-router'
import { onMounted, ref, watch, onUnmounted } from "vue"
// import { fetchGetApi } from '@/util/api';
const showLoader = ref<boolean>(false)
const router = useRouter()
const baseUrl = process.env.VUE_APP_BASE_URL

// Fetch user profile and store can_download permission
async function fetchUserProfile() {
  try {
    const token = localStorage.getItem('token')
    if (!token) {
      console.log('No token found, skipping profile fetch')
      return
    }

    const response = await fetch(`${baseUrl}api/user/profile`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    })

    if (response.ok) {
      const result = await response.json()
      if (result.success && result.data) {
        // Store can_download in localStorage
        localStorage.setItem('can_download', result.data.can_download.toString())
        
        // Optionally store other useful profile data
        localStorage.setItem('user_name', result.data.name)
        localStorage.setItem('user_email', result.data.email)
        localStorage.setItem('user_role', result.data.roleName || '')
        localStorage.setItem('user_id', result.data._id || result.data.id)
        
        console.log('User profile loaded globally:', result.data)
      }
    } else {
      console.error('Failed to fetch user profile')
    }
  } catch (error) {
    console.error('Error fetching user profile:', error)
  }
}

function add() {
  let localItem = JSON.stringify(useProductsStore().cart);
  localStorage.setItem('cart', localItem)

}
watch(
  () => router,
  () => {
    showLoader.value = true;
    setTimeout(() => {
      showLoader.value = false
    }, 2000);
  },
  { deep: true },
);

onMounted(() => {
  // Fetch user profile on app load
  fetchUserProfile()
  
  let allBgImageCover = document.getElementsByClassName('bg-img-cover');
  window.addEventListener('beforeunload', add)
  useProductsStore().intialUpload(JSON.parse(localStorage.getItem('cart')) || [])
  setTimeout(() => {
    for (let i = 0; i < allBgImageCover.length; i++) {
      var image = allBgImageCover[i]
      var parentEl: any = allBgImageCover[i].parentElement
      var src = image.getAttribute('src')
      parentEl.style.backgroundImage = "url(" + src + ")"
      parentEl.style.backgroundSize = "cover"
      parentEl.style.backgroundPosition = "center"
      parentEl.classList.add('bg-size')
      image.classList.add('d-none')
    }
  }, 0);

})
onUnmounted(() => {
  window.removeEventListener('beforeunload', add)

})
</script>
<style lang="scss"></style>